import { TableHead, TableRow, TableCell, Table, TableBody, TableSortLabel, TablePagination, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";
import axios from "axios";
import Cookies from 'js-cookie'
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import moment from 'moment'

const ContactUsQueries = (props) => {
    const [loading, setLoading] = useState(false);
    const [queries, setQueries] = useState([]);
    const [search, setsearch] = useState("")
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [skip, setskip] = React.useState(0)
    const [searchflag, setsearchflag] = useState(false)
    const [color, setColor] = useState("#000000");
    const [queryListSize, setQueryListSize] = useState("0");
    const [reset, setReset] = useState(false);

    const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

    const callback = () => {
        setLoading(false);
        setReset(false);
    }

    useEffect(() => {
        setLoading(true);
        fetchQueries(skip, rowsPerPage);
    }, [])

    useEffect(() => {
        setdata({ ...queries, rows: sortedItems })
    }, [queries])

    useEffect(() => {
        if (search !== "") {
            setsearchflag(true)
        }
        else if (search === "") {
            setsearchflag(false)
        }
    }, [search])

    useEffect(() => {
        if (reset) {
            setsearch("");
        }
    }, [reset])

    useEffect(() => {
        if (reset && searchflag === false) {
            // console.log("INSIDE RESET & SEARCH FLAG", searchflag);
            onChangeSearch();
        }
    }, [searchflag])


    const onChangeSearch = () => {
        setPage(0);
        setskip(0);
        setRowsPerPage(rowsPerPage)

        setLoading(true);
        fetchQueries(0, rowsPerPage);
    }


    const fetchQueries = async (skip, rowsPerPage) => {
        // alert("fetch search: " + search + " searchFlag: " + searchflag);
        const response = await axios.request({
            headers: {
                'Content-Type': 'application/json',
                'Authorization': Cookies.get('token')
            },
            method: 'post',
            data: { skip: skip, limit: rowsPerPage, searchWords: search, searchflag: searchflag },
            url: `${process.env.REACT_APP_SERVER_URL}/v1/cms/get-contact-us-queries`
        })
        if (response.data.success) {
            setQueryListSize(response.data.unSkippedSize)
            setQueries(response.data.data);
            callback();
        }
        else {
            toast.error(response.data.message)
            setQueries(response.data.data);
            callback();
        }

    }

    // const handleChangePage = (event, newPage) => {
    //     setPage(newPage);
    // };

    // const handleChangeRowsPerPage = event => {
    //     setRowsPerPage(+event.target.value);
    //     setPage(0);
    // };



    const handleChangePage = (event, newPage) => {

        const upcoming_result = ((newPage + 1) * rowsPerPage) - rowsPerPage;
        setskip(upcoming_result)
        setPage(newPage);
        setLoading(true)
        fetchQueries(upcoming_result, rowsPerPage)
    };

    const handleChangeRowsPerPage = async (event) => {
        setRowsPerPage(event.target.value);
        setPage(0);
        setskip(0);
        setLoading(true)
        fetchQueries(0, event.target.value)

    };



    // useEffect(() => {
    //     setPage(0);
    //     if (search === "") { setsearchflag(false) }
    //     else { setsearchflag(true) }
    // }, [search])

    var defaultSortBy = "createdAt";
    var defaultSortOrder = "desc";
    let [sortBy, setsortBy] = useState(defaultSortBy)             // default sort column
    let [sortOrder, setsortOrder] = useState(defaultSortOrder)    // default sort order

    const sortData = (sortBy, sortOrder, rows) => {
        let itemsToSort = JSON.parse(JSON.stringify(rows || queries));
        let sortedItems = [];
        let compareFn = null;
        switch (sortBy) {
            case "createdAt":
                compareFn = (i, j) => {

                    if (i.createdAt < j.createdAt) {
                        return sortOrder === "desc" ? 1 : -1;
                    } else {
                        if (i.createdAt > j.createdAt) {
                            return sortOrder === "desc" ? -1 : 1;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                break;
            case "firstName":
                compareFn = (i, j) => {

                    if (i.firstName < j.firstName) {
                        return sortOrder === "asc" ? -1 : 1;
                    } else {
                        if (i.firstName > j.firstName) {
                            return sortOrder === "asc" ? 1 : -1;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                break;
            case "lastName":
                compareFn = (i, j) => {

                    if (i.lastName < j.lastName) {
                        return sortOrder === "asc" ? -1 : 1;
                    } else {
                        if (i.lastName > j.lastName) {
                            return sortOrder === "asc" ? 1 : -1;
                        }
                        else {
                            return 0;
                        }
                    }

                };
                break;
            case "email":
                compareFn = (i, j) => {
                    if (i.email < j.email) {
                        return sortOrder === "asc" ? -1 : 1;
                    } else {
                        if (i.email > j.email) {
                            return sortOrder === "asc" ? 1 : -1;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                break;
            default:
                break;
        }
        console.log(`---->itemtosort${sortBy}`, itemsToSort)
        sortedItems = queries ? itemsToSort.sort(compareFn) : '';
        console.log('---->sortItems', sortedItems)
        return sortedItems;
    }

    const requestSort = (pSortBy) => {
        var newsortBy = sortBy;
        var newsortOrder = sortOrder;

        console.log('-->newsortBy', newsortBy)
        console.log('-->newsortOrder', newsortOrder)
        console.log('-->pSortBy', pSortBy)

        return event => {
            if (pSortBy === newsortBy) {
                newsortOrder = newsortOrder === "asc" ? "desc" : "asc";
            } else {
                newsortBy = pSortBy;
                newsortOrder = "asc";
            }

            var sortedItems = sortData(newsortBy, newsortOrder);
            setdata({ ...data, rows: sortedItems })
            setsortBy(newsortBy)
            setsortOrder(newsortOrder)
        };
    }

    var sortedItems = sortData(defaultSortBy, defaultSortOrder, queries);
    const [data, setdata] = useState({ ...queries, rows: sortedItems })

    return (
        <>
            <div className="dashContentHeader">
                <h5 className="dashHeading mb-0">Contact Us Queries</h5>
            </div>
            <div className="dashboardCardRow">
                <div className="input-group mb-4 search-menu">
                    <input type="text" className="form-control" onChange={(e) => { setsearch(e.target.value); }} onKeyDown={(e) => { if (e.keyCode === 13) { onChangeSearch() } }} value={search} placeholder="Search Using Email..." />
                    <div className="input-group-append">
                        <span className="input-group-text">
                            <i className="fa fa-search" aria-hidden="true"></i>
                        </span>
                    </div>
                    <button className="btn btn-custom-1" onClick={() => { setReset(true) }}>
                        <i class="fa fa-refresh" aria-hidden="true"></i> Reset</button>
                </div>
                <div className="listingTableRow">
                    <div className="listingTableHeader d-flex flex-wrap justify-content-between align-items-center pb-4 ">
                        <div className="custom-control custom-checkbox no-padding">
                            <label>Showing {searchflag ? queryListSize : data.rows.length} queries</label>

                        </div>
                        {/* <label className="right-label-checkbox">Showing {searchflag ? queryListSize : data.rows.length} queries
                            <input type="checkbox" />
                            <span className="checkmark"></span>
                        </label> */}
                    </div>
                    <div className="table-responsive">


                        <Table className="table customDashboardTable">
                            <TableHead>
                                <TableRow>
                                    <TableCell> <TableSortLabel active={sortBy === "firstName"} direction={sortOrder} onClick={requestSort("firstName")}>First Name</TableSortLabel> </TableCell>
                                    <TableCell> <TableSortLabel active={sortBy === "lastName"} direction={sortOrder} onClick={requestSort("lastName")}>Last Name</TableSortLabel> </TableCell>
                                    <TableCell> <TableSortLabel active={sortBy === "email"} direction={sortOrder} onClick={requestSort("email")}>Email</TableSortLabel> </TableCell>
                                    <TableCell>Phone</TableCell>
                                    <TableCell>Pref Time</TableCell>
                                    <TableCell>Message</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell className="action-col">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading &&
                                    (
                                        <TableRow>
                                            <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                            <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                            <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                            <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                            <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                            <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                            <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                            <TableCell className="action-col"><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                        </TableRow>
                                    )}

                                {!loading && data?.rows && data.rows
                                    // .filter(query => query.firstName.toLowerCase().includes(search.toLowerCase()) || query.lastName.toLowerCase().includes(search.toLowerCase()) || query.email.toLowerCase().includes(search.toLowerCase()))
                                    // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((query, index) => {
                                        let statusClass = ""
                                        if (query.status === "PENDING")
                                            statusClass = "btn-danger"
                                        else if (query.status === "IN PROGRESS")
                                            statusClass = "btn-warning"
                                        else
                                            statusClass = "btn-success"
                                        return (
                                            <TableRow key={index}>
                                                <TableCell>{query.firstName}</TableCell>
                                                <TableCell>{query.lastName}</TableCell>
                                                <TableCell>{query.email}</TableCell>
                                                <TableCell>{query.phone}</TableCell>
                                                <TableCell>{moment(query.prefTime).format('MMMM Do YYYY, h:mm:ss a')}</TableCell>
                                                <TableCell>{query.message}</TableCell>
                                                <TableCell><button className={`btn ${statusClass}`} disabled>{query.status}</button></TableCell>
                                                <TableCell className="action-col">
                                                    {/* <div className="dropdown">

                                                            <button className="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                <svg width="22" height="6" viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <circle cx="3" cy="3" r="3" fill="#C4C4C4" />
                                                                    <circle cx="11" cy="3" r="3" fill="#C4C4C4" />
                                                                    <circle cx="19" cy="3" r="3" fill="#C4C4C4" />
                                                                </svg>
                                                            </button>
                                                            <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                                                <Link className="dropdown-item" to={`/edit-contact-us-query-status/${query._id}`}>Edit</Link>
                                                            </div>
                                                        </div> */}
                                                    <ul className="action-list list-unstyled mb-0 d-flex align-items-center justify-content-center">
                                                        <li>
                                                            <Link to={`/edit-contact-us-query-status/${query._id}`} className="fa fa-pencil-square-o"></Link>
                                                        </li>
                                                    </ul>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                    )
                                }
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 100]}
                            component="div"
                            count={queryListSize}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />

                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactUsQueries
